export const CITY_ALIASES_BY_PROVIDER_HEADER_TITLES = {
	ID: 'ID аліаса',
	NAME: 'Аліас міста',
	CITY_ID: 'ID міста',
	CITY_NAME: 'Місто',
	PROVIDER_NAME: 'Провайдер',
	CREATED_AT: 'Створено',
	UPDATED_AT: 'Оновлено',
};
